<script setup lang="ts">
import CourseCardRow, { type CourseCredit } from './CourseCardRow.vue';

export interface InProgressCourse {
  id: string | number;
  title: string;
  progress: number;
  duration: string;
  practiceAreas?: string[];
  /** Credential codes the row should render as chips (e.g. `['cle']`, `['cle', 'cpe']`). Empty for non-credit content. */
  credentialCodes: string[];
  /** Fallback chip kind for non-credit content (e.g. `'microlearning'`, `'skills'`, `'pathway'`). */
  learningObjectTypeCode?: string;
  credits?: CourseCredit[];
  actionLabel: string;
  actionUrl: string;
  deliveryMode?: 'OnDemand' | 'Live';
  /** When an admin assigned the course — drives the "Assigned …" line on the card. */
  assignedAt?: string | null;
  /** Original recording / live event date — drives the "Recorded …" line on the card. */
  recordedDate?: string | null;
}

defineProps<{
  courses: InProgressCourse[];
}>();

const emit = defineEmits<{
  viewJurisdictions: [learningObjectId: string | number, credits: CourseCredit[]];
}>();

function handleViewJurisdictions(learningObjectId: string | number, credits: CourseCredit[]) {
  emit('viewJurisdictions', learningObjectId, credits);
}
</script>

<template>
  <div class="dashboard-section dashboard-section-full">
    <div class="section-header">
      <h2>Continue Learning</h2>
      <RouterLink to="/history" class="section-link">View all</RouterLink>
    </div>
    <div v-if="courses.length > 0" class="course-cards-list">
      <CourseCardRow
        v-for="course in courses"
        :key="course.id"
        v-bind="course"
        @view-jurisdictions="handleViewJurisdictions"
      />
    </div>
    <div v-else class="empty-state-container inline">
      <div class="empty-state-icon">
        <bb-icon name="school" decorative></bb-icon>
      </div>
      <h3 class="empty-state-title">No courses in progress</h3>
      <p class="empty-state-description">Start a course to track your progress here.</p>
    </div>
  </div>
</template>
